'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Loader = require('./components/Loader');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Loader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/loader/lib/index.js
// module id = 270
// module chunks = 3 4